export type SectionId =
  | 'hero'
  | 'program'
  | 'venue'
  | 'accommodation'
  | 'rsvp'
  | 'dressCode'
  | 'gift'
  | 'gallery'
  | 'contact';

export interface SectionConfig {
  visible: boolean;
  anchor: string;
  order: number;
  showInMenu: boolean;
}

export interface SiteConfig {
  event: {
    coupleShort: string;
    dateISO: [string, string];
    dateHumanCs: string;
    dateHumanEn: string;
    dateHumanDe: string;
    rsvpDeadlineISO: string;
    venueName: string;
    venueCity: string;
  };
  theme: {
    accent: string;
    accentDark: string;
    text: string;
    mute: string;
    bg: string;
  };
  sections: Record<SectionId, SectionConfig>;
  pages: {
    shop: {
      enabled: boolean;
      path: string;
      /** Stránka ukazuje "under construction" s tajným polem, dokud se
          nezadá unlockCode. Vypnutí gate = underConstruction: false. */
      underConstruction: boolean;
      unlockCode: string;
    };
  };
  links: {
    venueWebsite: string;
    venueMaps: string;
    rsvpForm: string;
    accommodationBooking: string;
    accommodationCode: string;
  };
}

export const siteConfig: SiteConfig = {
  event: {
    coupleShort: 'N & J',
    dateISO: ['2026-09-04', '2026-09-06'],
    dateHumanCs: '4.–6. září 2026',
    dateHumanEn: '4–6 September 2026',
    dateHumanDe: '4.–6. September 2026',
    rsvpDeadlineISO: '2026-06-01',
    venueName: 'Hotel Miura',
    venueCity: 'Čeladná',
  },
  theme: {
    accent: '#B60070',
    accentDark: '#8A0054',
    text: '#1A1A1A',
    mute: '#7F8184',
    bg: '#FFFFFF',
  },
  sections: {
    hero:          { visible: true,  anchor: '',              order: 0, showInMenu: false },
    program:       { visible: false, anchor: 'program',       order: 1, showInMenu: true  },
    venue:         { visible: false, anchor: 'venue',         order: 2, showInMenu: true  },
    accommodation: { visible: true,  anchor: 'accommodation', order: 4.5, showInMenu: true  },
    rsvp:          { visible: true,  anchor: 'rsvp',          order: 4, showInMenu: true  },
    dressCode:     { visible: true,  anchor: 'dresscode',     order: 5, showInMenu: true  },
    gift:          { visible: true,  anchor: 'gift',          order: 6, showInMenu: false },
    gallery:       { visible: false, anchor: 'gallery',       order: 7, showInMenu: true  },
    contact:       { visible: false, anchor: 'contact',       order: 8, showInMenu: true  },
  },
  pages: {
    shop: {
      enabled: true,
      path: '/shop',
      underConstruction: false,
      unlockCode: '',
    },
  },
  links: {
    venueWebsite: 'https://www.miura.cz',
    venueMaps: 'https://www.google.com/maps/search/?api=1&query=Hotel+Miura+%C4%8Celadn%C3%A1',
    rsvpForm: '#rsvp',
    accommodationBooking: 'https://www.secure-hotel-booking.com/d-edge/Miura-Hotel/J229/',
    accommodationCode: 'jnforever',
  },
};

export function orderedVisibleSections(): SectionId[] {
  return (Object.entries(siteConfig.sections) as [SectionId, SectionConfig][])
    .filter(([, c]) => c.visible)
    .sort(([, a], [, b]) => a.order - b.order)
    .map(([id]) => id);
}

export function menuSections(): SectionId[] {
  return orderedVisibleSections().filter(
    (id) => siteConfig.sections[id].showInMenu,
  );
}
